import React, { ReactNode } from 'react';

import './Tooltip.scss';

type Props = {
  children: ReactNode;
  description: string;
  className: string;
};

export const Tooltip: React.FC<Props> = ({
  children,
  description,
  className,
}) => {
  const showTooltip = () => {
    let tooltip = document.querySelector('.custom-tooltip');

    if (!tooltip) {
      const root = document.getElementById('root') as HTMLDivElement;
      tooltip = document.createElement('div');

      tooltip.className = 'custom-tooltip';
      tooltip.textContent = description;

      root.appendChild(tooltip);
    }

    return tooltip;
  };

  const setTooltipPosition = (x: number, y: number) => {
    const tooltip = showTooltip() as HTMLDivElement;

    tooltip.style.top = `${y + 25}px`;
    tooltip.style.left = `${x - 40}px`;
  };

  const closeTooltip = () => {
    const tooltip = document.querySelector('.custom-tooltip');

    if (tooltip) {
      tooltip.remove();
    }
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    if (description) {
      setTooltipPosition(event.clientX, event.clientY);
    }
  };

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (description) {
      setTooltipPosition(event.clientX, event.clientY);
    }
  };

  const handleMouseLeave = () => {
    if (description) {
      closeTooltip();
    }
  };

  return (
    <div
      className={className}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};
